import { render, staticRenderFns } from "./DLinkOffers.vue?vue&type=template&id=dc5a74f4&scoped=true"
import script from "./DLinkOffers.vue?vue&type=script&lang=js"
export * from "./DLinkOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5a74f4",
  null
  
)

export default component.exports